<template>
	<FormGroupBox
		v-if="modelId > 0 && viewModel.vouchers.length > 0 && $hasPermission('reservation.voucher.show')"
		title="Vouchers"
	>
		<b-form-row>
			<b-form-group class="col-12">
				<b-badge
					v-for="item in viewModel.vouchers"
					:key="item.id"
					variant="info"
					class="ml-1"
				>
					{{ item.voucher }}
				</b-badge>
			</b-form-group>
		</b-form-row>
	</FormGroupBox>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
export default {
	props:{
		modelId: Number
	},
	components: {
		FormGroupBox
	},
	computed:{
		viewModel(){
			return this.$store.state.reservation.viewModel
		}
	}
};
</script>
